module.exports = __webpack_public_path__ + "static/media/3DPPA10.dc845f23.jpg";